export enum SampleCategoryEnum {
    Personal = 0,
    Area = 1,
    Blank = 2
}